import React from "react";
import { FormBuilderElementsMappingService } from "../../../../services/builder/form-builder.elements-mapping.service";
const FormBuilderFormInterfaceHeader = ({ item, t }) => {
  if (!item) return null;
  const { h1, p } = FormBuilderElementsMappingService.getSingleElementHTMLTags(item);
  return /* @__PURE__ */ React.createElement("hgroup", { className: `${item.class}` }, /* @__PURE__ */ React.createElement("h1", null, t(h1.nodeValue)), p && /* @__PURE__ */ React.createElement("p", null, t(p.nodeValue)));
};
FormBuilderFormInterfaceHeader.displayName = "FormBuilderFormInterfaceHeader";
export default FormBuilderFormInterfaceHeader;
